/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-param-reassign */
import * as gatherUtil from '../utils/gatherUtil';

export enum Level {
  INFO = 0,
  ERROR = 1,
  WARNING = 2,
  DEBUG = 3,
}

export enum Platform {
  WEB = 'web',
}

export enum ReportType {
  DEVICE = 'device_report',
  NETWORK = 'network_report',
}

export interface ServerLogParam {
  uid?: number;
  title: string;
  level: Level;
  platform: Platform;
  reportType: ReportType;
  extInfo: string;
}

const log = async (serverLogParam: ServerLogParam) => {
  const uid = (await gatherUtil.getWebUser()).id;
  serverLogParam.uid = uid;
  const request = new XMLHttpRequest();
  request.addEventListener('load', () => {});
  request.addEventListener('error', () => {});
  request.open('POST', '//geek.163.com/path/user/autoReport', true);
  request.setRequestHeader('content-type', 'application/json');
  request.send(JSON.stringify(serverLogParam));
};

const networkReport = async (delayTime?: number) => {
  if (delayTime && delayTime > 0) {
    window.setTimeout(() => {
      networkReport();
    }, delayTime * 1000);
    return;
  }
  const webUser = await gatherUtil.getWebUser();
  const browser = gatherUtil.getBrowser();

  const serverDomains = [
    {
      host: 'https://steam.youdao.com',
      resource: '/favicon.png',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://geek.163.com',
      resource: '/res/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://kada.163.com',
      resource: '/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
  ];
  const jsDomains = [
    {
      host: 'https://shared-https.ydstatic.com',
      resource:
        '/panda/react/release/favicon.png',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://kdscdn.stu.126.net',
      resource:
        '/front-ide-scratch/build/static/assets/422b48c2206d5240a6717c92496ba21a.svg',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://gc.stu.126.net',
      resource: '/res/img/common/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://mgc.stu.126.net',
      resource: '/res/img/common/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://kw.stu.126.net',
      resource: '/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://edu-cms.nosdn.127.net',
      resource: '/topics/js/edu-polyfill6_e6036ff6e5066b433a189758cd1fab3b.js',
      type: gatherUtil.DomainFetchType.JS,
    },
  ];
  const mediaDomains = [
    {
      host: 'https://pandapub.nosdn.127.net',
      resource: '/pr_6u5mitnlf9rih8fg9lmcsa%3D%3D_2_1614753832_16.png',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://steam.nosdn.127.net',
      resource: '/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://edu-image.nosdn.127.net',
      resource: '/f52351bbbc744062a3b36a28d1ff3bea.png',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://jdvod9xhnfjp5.nosdn.127.net',
      resource: '/9df43869-7863-4925-98f5-c7cc583bc3df.jpg',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
    {
      host: 'https://mozart.study.163.com',
      resource: '/favicon.ico',
      type: gatherUtil.DomainFetchType.IMAGE,
    },
  ];
  const videoDomains = [
    {
      host: 'https://jdvodnthfjvqo.vod.126.net',
      resource:
        '/jdvodnthfjvqo/5e5c3ee9-877e-48ab-9332-c56bd1bfc852.mp4',
      type: gatherUtil.DomainFetchType.HEADER,
    },
    {
      host: 'https://jdvod9xhnfjp5.vod.126.net',
      resource:
        '/jdvod9xhnfjp5/nos/mp4/2020/05/18/1216739301_3ab1ec9bb81e43b8aed4fec1d112874a_sd.mp4?ak=67893b097cf3274fd7e9aa3263549571d993ab02cba51163dd18f8d50c0e8cc1d1f20fc8c6ef82bbb8260919e8ddcd4fb9a04a6dc0078fb900135a9b5c899dd9e3733688cd5b54142abee176b47cef39e88c01d51083d19b7f37bb90ce91f584ff95aee726907876d470c935a98ed2969466599be4f424183703589739adf00fcb8ec4c9d97c26298fee68fc20a7d05d4870092f831ac65589dad0d872f68a6436998ed577dd2cb418c206f27a0cb550',
      type: gatherUtil.DomainFetchType.HEADER,
    },
  ];

  Promise.all([
    gatherUtil.network(),
    Promise.all(gatherUtil.domainConnectivity(serverDomains)),
    Promise.all(gatherUtil.domainConnectivity(jsDomains)),
    Promise.all(gatherUtil.domainConnectivity(mediaDomains)),
    Promise.all(gatherUtil.domainConnectivity(videoDomains)),
  ]).then(
    ([
      network,
      serverConnectivity,
      jsConnectivity,
      mediaConnectivity,
      videoConnectivity,
    ]) => {
      setTimeout(() => {
        log({
          title: '用户网络情况报告',
          level: Level.INFO,
          platform: Platform.WEB,
          reportType: ReportType.NETWORK,
          extInfo: JSON.stringify({
            webUser,
            browser,
            network,
            serverConnectivity,
            jsConnectivity,
            mediaConnectivity,
            videoConnectivity,
          }),
        });
      }, Math.random() * 1000);
    },
  );
};

export default {
  log,
  networkReport,
};
